import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import FormSectionTitle from '@client/components/formComponents/formSectionTitle/FormSectionTitle';
import styles from './formSectionContainer.scss';

export default function FormSectionContainer(props) {
  const { children, number, title, titleComment, className, onClick } = props;

  return (
    <div
      className={classNames(styles.formSectionContainer, className)}
      onClick={onClick ? onClick : null}
    >
      <FormSectionTitle
        digit={number}
        headerText={title}
        headerComment={titleComment}
      />
      <div className={styles.contentContainer}>{children}</div>
    </div>
  );
}

FormSectionContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  number: PropTypes.number,
  title: PropTypes.string.isRequired,
  titleComment: PropTypes.string,
  onClick: PropTypes.func,
};
